import { useQuery } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";

const usePaymentsByService = ({ startDate, endDate, enabled = true }) => {
  const tenantVal = localStorage.getItem("kinesin-tenant");

  const formatDateForAPI = (date) => {
    return date ? date.format("YYYY-MM-DD") : null;
  };

  return useQuery({
    queryKey: ["payments-by-service", tenantVal, startDate, endDate],
    queryFn: async () => {
      const axiosInstance = createAxiosInstance();
      const params = new URLSearchParams();

      if (startDate) params.append("startDate", formatDateForAPI(startDate));
      if (endDate) params.append("endDate", formatDateForAPI(endDate));

      const queryString = params.toString() ? `?${params.toString()}` : "";
      const url = `${tenantVal}/payment-insights/payments-by-service${queryString}`;

      const response = await axiosInstance.get(url);

      return response.data;
    },
    enabled: enabled && !!tenantVal,
    refetchOnWindowFocus: false,
    staleTime: 5 * 60 * 1000,
  });
};

export { usePaymentsByService };
